/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.getPublicAmazonProductVariants

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.getPublicAmazonProductVariants.GetPublicAmazonProductVariantsApi
import features.getPublicAmazonProductVariants.models.PublicRewardResponseModel
import features.getPublicAmazonProductVariants.serializeGetPublicAmazonProductVariantsState



/**
 * Get a public reward with external product variants by external product id [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("GetPublicAmazonProductVariantsApi")
class GetPublicAmazonProductVariantsApiJs {

    /**
     * Get a public reward with external product variants by external product id
     */
    fun getPublicAmazonProductVariants(
        overrideHeaders: String?, 
        rewardSlug: String,
        externalProductId: String
    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = GetPublicAmazonProductVariantsApi().getPublicAmazonProductVariants(
            overrideHeaders = decodedOverrideHeaders,
                        rewardSlug = rewardSlug,
            externalProductId = externalProductId
        ).toJsonResult<PublicRewardResponseModel>()
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observeGetPublicAmazonProductVariantsState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        GetPublicAmazonProductVariantsApi().getPublicAmazonProductVariantsState.serializeGetPublicAmazonProductVariantsState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
